import { PeelingRateBasedEnum } from "../enums";

export class ScopeGradeReq{
    scope : string;
    grade : number;
    priceBasedOn : PeelingRateBasedEnum
    isRRP ?: boolean

    constructor(scope : string,grade : number,priceBasedOn : PeelingRateBasedEnum,isRRP ?: boolean){
        this.scope = scope
        this.grade = grade
        this.priceBasedOn = priceBasedOn
        this.isRRP = isRRP
    }
}